import { useFormikContext } from 'formik';
import { Button } from 'shared-components';
import { ButtonIntent, ButtonTier } from 'shared-components';
import { FormGroup } from 'shared-components';
// import { Album } from './albums.types';
import styles from './album-details.module.css';
import {
  useDeleteAlbumCoverMutation,
  useGetAlbumCoverQuery,
} from './albums.api';
import { useAppDispatch } from '../../app/hooks';
import { open } from '../modal/modalSlice';
import { toast } from 'react-toastify';
import { IAlbum } from '@topshots/core-models';
import { CardContent } from 'shared-components';
import { Label } from 'shared-components';
import { Input } from 'shared-components';
import classNames from 'classnames';
import { FormLayout } from 'shared-components';

export const AlbumDetails = ({ album }: { album?: IAlbum }) => {
  const { getFieldProps } = useFormikContext<IAlbum>();
  const [deleteCover] = useDeleteAlbumCoverMutation();
  const {
    data,
    isLoading: isLoadingCover,
    isFetching: isFetchingCover,
    refetch: refetchCover,
  } = useGetAlbumCoverQuery(album?._id.toString() ?? '');
  const dispatch = useAppDispatch();
  return (
    <CardContent>
      <FormLayout className={styles.details}>
        <FormGroup className={styles.coverImage}>
          <Label htmlFor="cover">Cover</Label>

          {isLoadingCover || isFetchingCover ? (
            <span>loading...</span>
          ) : (
            <>
              <div
                className={classNames(styles.coverImage__cover, {
                  [styles.coverImage__cover_empty]: !data?.url,
                  [styles.coverImage__cover_full]: data?.url,
                })}
                style={{
                  backgroundImage: `url(${data?.url})`,
                }}
              ></div>
              <div className={styles.coverImage__buttons}>
                {data?.url && (
                  <Button
                    onClick={async () => {
                      if (
                        // eslint-disable-next-line no-restricted-globals
                        confirm('Are you sure you want to clear the cover?')
                      ) {
                        await deleteCover(album?._id.toString() ?? '');
                        refetchCover();
                        toast.success('Cover cleared');
                      }
                    }}
                    intent={ButtonIntent.Negative}
                    tier={ButtonTier.Secondary}
                  >
                    Clear
                  </Button>
                )}
                <Button
                  className="w-100"
                  onClick={() => {
                    dispatch(
                      open({
                        title: 'Change cover',
                        contentKey: 'album-cover-upload',
                        contentPayload: {
                          albumId: album?._id,
                        },
                      })
                    );
                  }}
                  intent={ButtonIntent.Positive}
                  tier={ButtonTier.Secondary}
                >
                  {data?.url ? 'Change' : 'Upload'}
                </Button>
              </div>
            </>
            //  {data?.url && <img src={data?.url} alt="cover" />}
          )}
        </FormGroup>

        <FormGroup>
          <Label htmlFor="name">Name</Label>
          <Input {...getFieldProps('name')} type="text" id="name" />
        </FormGroup>
      </FormLayout>
    </CardContent>
  );
};
